// Turkish phone → E.164 helpers for tel: and wa.me links
export const phoneToE164 = (phone) => {
  if (!phone) return "";
  let d = String(phone).replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.startsWith("90") && d.length >= 12) return d;
  if (d.startsWith("0")) return "90" + d.slice(1);
  if (d.length === 10) return "90" + d;
  return d;
};

export const telHref = (phone) => {
  const e = phoneToE164(phone);
  return e ? `tel:+${e}` : "";
};

export const waHref = (phone, message = "") => {
  const e = phoneToE164(phone);
  if (!e) return "";
  const q = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${e}${q}`;
};
